import { render } from "./protocol_table.vue?vue&type=template&id=46657174"
import script from "./protocol_table.vue?vue&type=script&lang=js"
export * from "./protocol_table.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/protocols/list/protocol_table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46657174"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46657174', __exports__)) {
    console.log('reload')
    api.reload('46657174', __exports__)
  }
  
  module.hot.accept("./protocol_table.vue?vue&type=template&id=46657174", () => {
    console.log('re-render')
    api.rerender('46657174', render)
  })

}


export default __exports__